import { DocumentType } from '~/db_types';
import { CosmicIcons } from '~/nasa_ui/utils/ui/CosmicIcons';
import { EntityType } from '../cosmic';
import { DocumentTypeDisplay } from './document';
export var AuthorityCode;
(function (AuthorityCode) {
    AuthorityCode["_1149"] = "_1149";
    AuthorityCode["_290"] = "_290";
    AuthorityCode["_528"] = "_528";
    AuthorityCode["ADP"] = "ADP";
    AuthorityCode["C_NONCONFORMANCE_REPORT"] = "C_NONCONFORMANCE_REPORT";
    AuthorityCode["C_TPS"] = "C_TPS";
    AuthorityCode["DD250"] = "DD250";
    AuthorityCode["DELIVERY_ORDER"] = "DELIVERY_ORDER";
    AuthorityCode["DR"] = "DR";
    AuthorityCode["EC"] = "EC";
    AuthorityCode["EZT"] = "EZT";
    AuthorityCode["FAB"] = "FAB";
    AuthorityCode["FIAR"] = "FIAR";
    AuthorityCode["GSA_FORM_1449"] = "GSA_FORM_1449";
    AuthorityCode["INV"] = "INV";
    AuthorityCode["OTH"] = "OTH";
    AuthorityCode["PO"] = "PO";
    AuthorityCode["TCDS"] = "TCDS";
    AuthorityCode["TPS"] = "TPS";
    AuthorityCode["WAIVER"] = "WAIVER";
    AuthorityCode["YTN"] = "YTN";
})(AuthorityCode || (AuthorityCode = {}));
export const AuthorityCodeToCosmicIcon = new Map([
    [AuthorityCode._1149, CosmicIcons['movement']],
    [AuthorityCode._290, CosmicIcons['movement']],
    [AuthorityCode._528, CosmicIcons['movement']],
    [AuthorityCode.ADP, CosmicIcons[DocumentType.ACCEPTANCE_DATA_PACK]],
    [AuthorityCode.C_NONCONFORMANCE_REPORT, CosmicIcons[DocumentType.C_NONCONFORMANCE_REPORT]],
    [AuthorityCode.C_TPS, CosmicIcons[DocumentType.C_TPS]],
    [AuthorityCode.DD250, CosmicIcons['movement']],
    [AuthorityCode.DELIVERY_ORDER, CosmicIcons[DocumentType.DELIVERY_ORDER]],
    [AuthorityCode.DR, CosmicIcons[DocumentType.DISCREPANCY_REPORT]],
    [AuthorityCode.EC, CosmicIcons[DocumentType.ENGINEERING_CHANGE]],
    [AuthorityCode.EZT, CosmicIcons['movement']],
    [AuthorityCode.FAB, CosmicIcons[EntityType.DOCUMENT]],
    [AuthorityCode.FIAR, CosmicIcons[DocumentType.FAILURE_INVESTIGATION_ANOMALY_REPORT]],
    [AuthorityCode.GSA_FORM_1449, 'fa-solid fa-money-check-pen'],
    [AuthorityCode.INV, CosmicIcons[EntityType.INVENTORY]],
    [AuthorityCode.OTH, CosmicIcons[DocumentType.OTHER_DOCUMENT]],
    [AuthorityCode.PO, 'fa-solid fa-money-check-pen'],
    [AuthorityCode.TPS, CosmicIcons[DocumentType.TPS]],
    [AuthorityCode.TCDS, CosmicIcons[DocumentType.OTHER_DOCUMENT]],
    [AuthorityCode.WAIVER, CosmicIcons[DocumentType.WAIVER]],
    [AuthorityCode.YTN, CosmicIcons[DocumentType.YELLOW_TAG_NOTICE]]
]);
export const AuthorityCodeToCosmicIconColor = new Map([
    [AuthorityCode._1149, 'var(--v-movement-base)'],
    [AuthorityCode._290, 'var(--v-movement-base)'],
    [AuthorityCode._528, 'var(--v-movement-base)'],
    [AuthorityCode.ADP, 'var(--v-documents-base)'],
    [AuthorityCode.C_NONCONFORMANCE_REPORT, 'var(--v-documents-base)'],
    [AuthorityCode.C_TPS, 'var(--v-documents-base)'],
    [AuthorityCode.DD250, 'var(--v-movement-base)'],
    [AuthorityCode.DELIVERY_ORDER, 'var(--v-documents-base)'],
    [AuthorityCode.DR, 'var(--v-documents-base)'],
    [AuthorityCode.EC, 'var(--v-documents-base)'],
    [AuthorityCode.EZT, 'var(--v-movement-base)'],
    [AuthorityCode.FAB, 'var(--v-documents-base)'],
    [AuthorityCode.FIAR, 'var(--v-documents-base)'],
    [AuthorityCode.GSA_FORM_1449, 'var(--v-documents-base)'],
    [AuthorityCode.INV, 'var(--v-item_instances-base)'],
    [AuthorityCode.OTH, 'var(--v-documents-base)'],
    [AuthorityCode.PO, 'var(--v-documents-base)'],
    [AuthorityCode.TPS, 'var(--v-documents-base)'],
    [AuthorityCode.TCDS, 'var(--v-documents-base)'],
    [AuthorityCode.WAIVER, 'var(--v-documents-base)'],
    [AuthorityCode.YTN, 'var(--v-documents-base)']
]);
export const AuthorityCodeToDocumentType = new Map([
    [AuthorityCode._1149, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode._290, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode._528, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.ADP, DocumentType.ACCEPTANCE_DATA_PACK],
    [AuthorityCode.C_NONCONFORMANCE_REPORT, DocumentType.C_NONCONFORMANCE_REPORT],
    [AuthorityCode.C_TPS, DocumentType.C_TPS],
    [AuthorityCode.DD250, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.DELIVERY_ORDER, DocumentType.DELIVERY_ORDER],
    [AuthorityCode.DR, DocumentType.DISCREPANCY_REPORT],
    [AuthorityCode.EC, DocumentType.ENGINEERING_CHANGE],
    [AuthorityCode.FAB, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.FIAR, DocumentType.FAILURE_INVESTIGATION_ANOMALY_REPORT],
    [AuthorityCode.GSA_FORM_1449, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.INV, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.OTH, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.PO, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.TPS, DocumentType.TPS],
    [AuthorityCode.TCDS, DocumentType.OTHER_DOCUMENT],
    [AuthorityCode.WAIVER, DocumentType.WAIVER],
    [AuthorityCode.YTN, DocumentType.YELLOW_TAG_NOTICE]
]);
export const AuthorityCodeDisplay = new Map([
    [AuthorityCode._1149, 'DD1149'],
    [AuthorityCode._290, 'JSC290'],
    [AuthorityCode._528, 'JSC528'],
    [AuthorityCode.ADP, DocumentTypeDisplay.get(DocumentType.ACCEPTANCE_DATA_PACK)],
    [AuthorityCode.C_NONCONFORMANCE_REPORT, DocumentTypeDisplay.get(DocumentType.C_NONCONFORMANCE_REPORT)],
    [AuthorityCode.C_TPS, DocumentTypeDisplay.get(DocumentType.C_TPS)],
    [AuthorityCode.DD250, 'DD250'],
    [AuthorityCode.DELIVERY_ORDER, 'Delivery order'],
    [AuthorityCode.DR, DocumentTypeDisplay.get(DocumentType.DISCREPANCY_REPORT)],
    [AuthorityCode.EC, DocumentTypeDisplay.get(DocumentType.ENGINEERING_CHANGE)],
    [AuthorityCode.EZT, 'EZT'],
    [AuthorityCode.FAB, 'FAB action breakdown'],
    [AuthorityCode.FIAR, 'FIAR'],
    [AuthorityCode.GSA_FORM_1449, 'GSA 1449'],
    [AuthorityCode.INV, 'Inventory'],
    [AuthorityCode.OTH, DocumentTypeDisplay.get(DocumentType.OTHER_DOCUMENT)],
    [AuthorityCode.PO, 'Purchase order'],
    [AuthorityCode.TCDS, 'Time cycle data sheet (TCDS)'],
    [AuthorityCode.TPS, DocumentTypeDisplay.get(DocumentType.TPS)],
    [AuthorityCode.YTN, DocumentTypeDisplay.get(DocumentType.YELLOW_TAG_NOTICE)],
    [AuthorityCode.WAIVER, DocumentTypeDisplay.get(DocumentType.WAIVER)]
]);
export const AuthorityCodeRequiresDocument = new Map([
    [AuthorityCode.ADP, false],
    [AuthorityCode.C_NONCONFORMANCE_REPORT, true],
    [AuthorityCode.C_TPS, true],
    [AuthorityCode.DR, true],
    [AuthorityCode.EC, true],
    [AuthorityCode.FAB, false],
    [AuthorityCode.FIAR, false],
    [AuthorityCode.GSA_FORM_1449, false],
    [AuthorityCode.INV, false],
    [AuthorityCode.OTH, false],
    [AuthorityCode.PO, true],
    [AuthorityCode.TCDS, false],
    [AuthorityCode.TPS, true],
    [AuthorityCode.YTN, false],
    [AuthorityCode.WAIVER, false]
]);
